// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type AccountCreate,
  AccountCreateFromJSON,
  AccountCreateToJSON,
} from "../models/AccountCreate";
import { type AccountRead, AccountReadFromJSON, AccountReadToJSON } from "../models/AccountRead";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface AccountCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  accountCreate: AccountCreate;
}

/**
 *
 */
export class AccountsApi extends runtime.BaseAPI {
  /**
   * Creates request options for accountCreate without sending the request
   */
  async accountCreateRequestOpts(
    requestParameters: AccountCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling accountCreate().'
      );
    }

    if (requestParameters["accountCreate"] == null) {
      throw new runtime.RequiredError(
        "accountCreate",
        'Required parameter "accountCreate" was null or undefined when calling accountCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    let urlPath = `/tenants/{tenant_id}/accounts`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: AccountCreateToJSON(requestParameters["accountCreate"]),
    };
  }

  /**
   * Create an account at accounts.ranawaterintelligence.com. A Tenant and Invitation are required.
   * Create an account
   */
  async accountCreateRaw(
    requestParameters: AccountCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AccountRead>> {
    const requestOptions = await this.accountCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => AccountReadFromJSON(jsonValue));
  }

  /**
   * Create an account at accounts.ranawaterintelligence.com. A Tenant and Invitation are required.
   * Create an account
   */
  async accountCreate(
    requestParameters: AccountCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AccountRead> {
    const response = await this.accountCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
